import { createElement, Component, createContext } from 'react';

function __extends(d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _a, _b;
var GlitzContextProvider = (_a = createContext({ glitz: null }), _a.Provider), GlitzContextConsumer = _a.Consumer;
var ThemeContextProvider = (_b = createContext({ theme: undefined }), _b.Provider), ThemeContextConsumer = _b.Consumer;

var GlitzProvider = /** @class */ (function (_super) {
    __extends(GlitzProvider, _super);
    function GlitzProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GlitzProvider.prototype.render = function () {
        return createElement(GlitzContextProvider, { value: this.props }, this.props.children);
    };
    return GlitzProvider;
}(Component));

var GlitzProvider$1 = /** @class */ (function (_super) {
    __extends(GlitzProvider, _super);
    function GlitzProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GlitzProvider.prototype.render = function () {
        return createElement(ThemeContextProvider, { value: this.props }, this.props.children);
    };
    return GlitzProvider;
}(Component));

var STYLED_TYPE_PROPERTY = '$$GLITZ_STYLED_TYPE';
var Type;
(function (Type) {
    Type[Type["Element"] = 0] = "Element";
    Type[Type["ElementLike"] = 1] = "ElementLike";
})(Type || (Type = {}));
function isType(type) {
    return STYLED_TYPE_PROPERTY in type;
}

function applyClassName(component) {
    var _a;
    return _a = {},
        _a[STYLED_TYPE_PROPERTY] = Type.ElementLike,
        _a.value = component,
        _a;
}
function isElementLikeType(type) {
    return isType(type) && type[STYLED_TYPE_PROPERTY] === Type.ElementLike;
}

function createElementType(tag) {
    var _a;
    return _a = {},
        _a[STYLED_TYPE_PROPERTY] = Type.Element,
        _a.value = tag,
        _a;
}
function isElementType(type) {
    return isType(type) && type[STYLED_TYPE_PROPERTY] === Type.Element;
}
function createPredefined(tag) {
    return function (style) { return factory(createElementType(tag), [style]); };
}
function assignPredefined(target) {
    for (var _i = 0, predefinedElements_1 = predefinedElements; _i < predefinedElements_1.length; _i++) {
        var tag = predefinedElements_1[_i];
        target[tag[0].toUpperCase() + tag.slice(1)] = factory(createElementType(tag), []);
        target[tag] = createPredefined(tag);
    }
    return target;
}
var predefinedElements = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'svg',
    'animate',
    'circle',
    'defs',
    'ellipse',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'symbol',
    'text',
    'tspan',
    'use',
];

// The empty class helps us identify when it's a styled component in `isStyledComponent`
var StyledSuper = /** @class */ (function (_super) {
    __extends(StyledSuper, _super);
    function StyledSuper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StyledSuper;
}(Component));
function isStyledComponent(type) {
    return typeof type === 'function' && type.prototype instanceof StyledSuper;
}

function createRenderer(type, statics) {
    var lastDynamics;
    var lastComposer;
    var createComposer = function (dynamics) {
        if (lastDynamics === dynamics && lastComposer) {
            return lastComposer;
        }
        lastDynamics = dynamics;
        var lastStyles;
        var lastAdditionals;
        return (lastComposer = function (additionals) {
            var isPure = lastAdditionals === additionals;
            if (isPure && lastStyles) {
                return lastStyles;
            }
            lastAdditionals = additionals;
            if (!dynamics && !additionals) {
                return (lastStyles = statics);
            }
            return (lastStyles = [].concat(additionals || [], statics || [], dynamics || []));
        });
    };
    var lastGlitz;
    var lastTheme;
    var lastApplier;
    var lastApplierComposer;
    var totalCacheInvalidations = 0;
    var createApplier = function (glitz, theme, compose) {
        if (lastGlitz === glitz && lastApplierComposer === compose && lastTheme === theme && lastApplier) {
            return lastApplier;
        }
        lastGlitz = glitz;
        lastTheme = theme;
        lastApplierComposer = compose;
        var lastStyles;
        var lastClassName;
        return (lastApplier = function (additionals) {
            var styles = compose(additionals);
            var isPure = styles === lastStyles;
            lastStyles = styles;
            if (!styles) {
                return;
            }
            if (isPure && lastClassName) {
                return lastClassName;
            }
            if (process.env.NODE_ENV !== 'production') {
                if (typeof requestAnimationFrame === 'function') {
                    totalCacheInvalidations++;
                    if (totalCacheInvalidations === 3) {
                        console.warn("Multiple re-renders of a styled component with invalidated cache was detected. Either make sure it doesn't re-render or make sure the cache is intact. More info: https://git.io/fxYyd");
                    }
                    var currentCacheInvalidations_1 = totalCacheInvalidations;
                    // Jump two frames to reset counter if there hasn't been any more renders with cache invalidation
                    requestAnimationFrame(function () {
                        requestAnimationFrame(function () {
                            if (totalCacheInvalidations === currentCacheInvalidations_1) {
                                totalCacheInvalidations = 0;
                            }
                        });
                    });
                }
            }
            return (lastClassName = glitz.injectStyle(styles, theme));
        });
    };
    var createElement$$1 = isElementType(type) || isElementLikeType(type)
        ? function (currentProps, apply) {
            return createElement(type.value, passingProps({ className: combineClassNames(currentProps.className, apply()) }, currentProps));
        }
        : isStyledComponent(type)
            ? function (currentProps, _a, compose) {
                return createElement(type, passingProps({ css: compose() }, currentProps));
            }
            : function (currentProps, _a, compose) {
                return createElement(type, passingProps({ compose: compose }, currentProps));
            };
    return function (currentProps) {
        return createElement(GlitzContextConsumer, null, function (_a) {
            var glitz = (_a === void 0 ? {} : _a).glitz;
            return createElement(ThemeContextConsumer, null, function (_a) {
                var theme = (_a === void 0 ? {} : _a).theme;
                if (process.env.NODE_ENV !== 'production') {
                    if (!glitz) {
                        throw new Error("The `<GlitzProvider>` doesn't seem to be used correctly because the core instance couldn't be found");
                    }
                }
                var compose = createComposer(currentProps.css);
                return createElement$$1(currentProps, createApplier(glitz, theme, compose), compose);
            });
        });
    };
}
function combineClassNames(a, b) {
    return a && b ? a + " " + b : a ? a : b;
}
function passingProps(destination, props) {
    for (var name in props) {
        var value = props[name];
        if (name !== 'css') {
            if (name === 'innerRef') {
                name = 'ref';
            }
            // Don't override preexisting props
            destination[name] = destination[name] || value;
        }
    }
    return destination;
}

function create(type, statics) {
    return isStyledComponent(type) ? type.compose(statics) : factory(type, statics);
}
function factory(type, statics) {
    var Styled = /** @class */ (function (_super) {
        __extends(Styled, _super);
        function Styled(props) {
            var _this = _super.call(this, props) || this;
            var renderWithProps = createRenderer(type, statics);
            _this.render = function () { return renderWithProps(_this.props); };
            return _this;
        }
        Styled.compose = function (additionals) {
            return factory(type, additionals ? statics.concat(additionals) : statics);
        };
        return Styled;
    }(StyledSuper));
    if (process.env.NODE_ENV !== 'production') {
        var inner = isElementType(type) || isElementLikeType(type) ? type.value : type;
        Styled.displayName = "Styled(" + (typeof inner === 'string' ? inner : inner.displayName || inner.name || 'Unknown') + ")";
    }
    return Styled;
}

function customStyled(arg1, arg2) {
    return isStyle(arg1) ? decorator(arg1) : create(arg1, arg2 ? [arg2] : []);
}
function decorator(preStyle) {
    return function (innerComponent, style) { return create(innerComponent, style ? [preStyle, style] : [preStyle]); };
}
function isStyle(arg) {
    return typeof arg === 'object' && !isType(arg);
}

// @ts-ignore
var styled = assignPredefined(customStyled);

export { GlitzProvider, GlitzProvider$1 as ThemeProvider, styled, StyledSuper, createRenderer, applyClassName, isElementLikeType, isStyledComponent };
